








import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ModalView from '@/components/helper/modal-view.vue';
import FormBase from '@/components/helper/form-base.vue';
import Util from '@/lib/util';
import PageRequest from '@/store/entities/page-request';
import ListBase from '@/lib/listbase';
import Segment from '@/store/entities/tracing/segment';

class PageSegmentRequest extends PageRequest {
    segment: number = null;
}

@Component({
    components: { ModalView, FormBase},
    watch: {
        value: function (val) {
            let obj = (this as any);
            obj.segment = Util.extend(true, {}, this.$store.state.segment.editModel);
            obj.modalShow = val;
        },
        modalShow: function (val) {
            if (!val) {
                this.$emit('input', false);
            } else {
                (this as any).initForm();
            }
        }
    }
})

export default class SegmentForm extends ListBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    segment: Segment = new Segment();
    pagerequest: PageSegmentRequest = new PageSegmentRequest();
    modalShow: boolean = false;
    formBase: boolean = true;
    modalSetting: any = {
        entity: "segment",
        title: 'Segmento',
        width: "500px",
        showForm: false,
    };

    items = [
        this.gItem({ type: 'text', prop: 'code', label: 'Codigo', prefix: '#', readonly: true, size: 3 }),
        this.gItem({ type: 'text', prop: 'name', label: 'Nombre', required: true, size: 9 }),
        this.gItem({ type: 'text', prop: 'min_year', label: '>= Anios', size: 3 }),
        this.gItem({ type: 'text', prop: 'max_year', label: '<= Anios', size: 3 }),
        this.gItem({ type: 'spacer', size: 6 }),
    ] 

    get isEditing() {
        return this.$store.state.segment.editModel.id > 0;
    }
    
    async initForm() {
        if (this.isEditing) {               
        }
    }

    async save() {
        if ((this.$refs.entityForm1 as any).validate()) {
            let model = Util.extend(true, {}, this.segment);
            model.sub_segments = this.$store.state.subsegment.list;
            
            await this.$store.dispatch({
                type: 'segment/' + (this.segment.id > 0 ? 'update' : 'create'),
                data: model
            });
            this.$emit('save-success');
            this.cancel();
            if (this.segment.id > 0)
                Util.abp.notify.success(this, 'Informacion de Segmento actualizada!');
            else
                Util.abp.notify.success(this, 'El Segmento ha sido creada!');

            this.$store.commit('segment/setActiveList', []);
            await this.$store.dispatch({
                type: 'segment/getAllActive',
                data: { force: true }
            });
        }
    }

    cancel() {
        this.$emit('input', false);
    }

    mounted() {
    }

    created() {
    }
}
